<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { EcxBadge } from '@ecx/ui'
import { useBulkImportStore } from '@/stores/bulkImport'
import BulkImportErrorList from '../errors/BulkImportErrorList.vue'
import BulkImportSummaryHero from '../shared/BulkImportSummaryHero.vue'

// errors vazio = planilha com estrutura errada (backend não parseou linhas), não erro de campo
const { t } = useI18n()
const store = useBulkImportStore()

const hasErrors = computed(() => store.errors.length > 0)
const errorCount = computed(
  () => store.errorsPagination?.count ?? store.errors.length,
)
const isEdit = computed(() => store.mode === 'edit')
</script>

<template>
  <div class="flex flex-col flex-1 pb-6">
    <div
      class="flex flex-col items-center justify-center text-center gap-3 px-6"
      :class="isEdit && !hasErrors ? 'flex-1 py-6' : 'pt-20 pb-6'"
      data-testid="validation-error-hero"
    >
      <BulkImportSummaryHero accent="red" />

      <h2 class="text-2xl font-semibold text-grey-950">
        {{ t('corp.bulk_import.validation_error.title') }}
      </h2>

      <p v-if="!hasErrors" class="text-sm text-grey-600 max-w-sm">
        {{
          t(
            isEdit
              ? 'corp.bulk_import.validation_error.subtitle_template_mismatch_edit'
              : 'corp.bulk_import.validation_error.subtitle_template_mismatch',
          )
        }}
      </p>

      <p v-else class="text-sm text-grey-600 max-w-sm">
        {{
          t(
            'corp.bulk_import.validation_error.subtitle',
            { count: errorCount },
            errorCount,
          )
        }}
      </p>
    </div>

    <div
      v-if="hasErrors"
      class="mx-6 mb-4 border border-grey-200 rounded-lg overflow-hidden"
      data-testid="error-panel"
    >
      <div
        class="flex items-center justify-between px-4 pt-4 pb-2"
      >
        <span class="text-base font-normal text-grey-950">
          {{ t('corp.bulk_import.validation_error.panel_title') }}
        </span>
        <EcxBadge
          :text="
            t(
              'corp.bulk_import.validation_error.count_found',
              { count: errorCount },
              errorCount,
            )
          "
          variant="default"
          data-testid="error-count-badge"
        />
      </div>

      <BulkImportErrorList
        :errors="store.errors"
        :pagination="store.errorsPagination"
        :loading="store.isLoadingErrors"
        @page-change="store.loadErrorsPage"
      />
    </div>
  </div>
</template>
